<div class="gradient text-center py-6 my-5 gy-5 g-lg-5" appAos>
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <img class="mx-auto d-block banner-image mb-5" [src]="body()?.primary?.image?.url" />
                <div [innerHTML]="body()?.primary?.title | renderHtml : htmlSerializer"></div>
            </div>
        </div>
    </div>
</div>
